var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey_numbers-list"},_vm._l((_vm.arrFromLength),function(n,k){return _c('div',{key:n,ref:"numItems",refInFor:true,staticClass:"survey_numbers-list__number",class:{
      'survey_numbers-list__number--answered': _vm.answeredByIndex[k] && k !== _vm.activeIndex,
      'survey_numbers-list__number--active': k === _vm.activeIndex
    },on:{"click":function($event){return _vm.$emit('setActiveIndex', k)}}},[_c('span',[_vm._v(_vm._s(k+1))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }